import { Button } from "antd";
import { AlertTriangleIcon } from "lucide-react";
import PropTypes from "prop-types";

/** Tighter Ant Design banner padding, especially on small screens. */
export const BANNER_ALERT_COMPACT_CLASS =
    "[&_.ant-alert]:!items-start [&_.ant-alert]:!py-2 [&_.ant-alert]:!px-3 sm:[&_.ant-alert]:!items-center [&_.ant-alert-content]:!min-w-0 [&_.ant-alert-message]:!w-full";

const BannerAlertMessage = ({ children, actionLabel, onAction }) => (
    <div className="flex w-full min-w-0 flex-col gap-2 sm:flex-row sm:items-center sm:justify-center sm:gap-4">
        {/* Phones: icon + text fill the width above a full-width button. From `sm` up
            everything sizes to its content so icon, text and button centre as one group
            instead of the icon and button being pushed to opposite edges. */}
        <div className="flex min-w-0 flex-1 items-start gap-2 sm:flex-initial sm:items-center">
            <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0 sm:h-5 sm:w-5" aria-hidden />
            <p className="m-0 min-w-0 flex-1 text-left text-xs leading-snug sm:flex-initial sm:text-sm sm:leading-normal lg:text-[15px]">
                {children}
            </p>
        </div>
        {actionLabel ? (
            <Button
                className="!h-8 w-full shrink-0 !px-4 !text-xs font-medium sm:w-auto sm:!text-sm"
                size="small"
                shape="round"
                variant="outlined"
                color="primary"
                onClick={onAction}>
                {actionLabel}
            </Button>
        ) : null}
    </div>
);

BannerAlertMessage.propTypes = {
    children: PropTypes.node.isRequired,
    actionLabel: PropTypes.string,
    onAction: PropTypes.func,
};

BannerAlertMessage.defaultProps = {
    actionLabel: null,
    onAction: undefined,
};

export default BannerAlertMessage;
